module.exports = __webpack_public_path__ + "static/img/best.8db0a81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/best.png
// module id = DqhU
// module chunks = 0